import axiosInstance from "../utils/axios";

export const GetQuizByIdService = async (values) => {
  return await axiosInstance().get("/getQuizById", { params: values });
};

export const GetQuestionsService = async (values) => {
  return await axiosInstance().get("/getQuestions", { params: values });
};

export const GetQuizQuestionsService = async (values) => {
  return await axiosInstance().get("/getQuizQuestions", { params: values });
};

export const SubmitQuizService = async (values) => {
  return await axiosInstance().post("submitQuiz", values);
};

export const AssessmentSetToFinalService = async (values) => {
  return await axiosInstance().post("assessmentSetToFinal", values);
};

export const SubmitSingleAnswerService = async (values) => {
  return await axiosInstance().post("submitSingleAnswer", values);
};

export const SubmitSingleAnswersService = async (values) => {
  return await axiosInstance().post("submitSingleAnswers", values);
};

export const quizResultWithTime = async (values) => {
  return await axiosInstance().post("/quizQuestion", values);
};

export const longAndShortAns = async (values) => {
  return await axiosInstance().post("/longAndShortAns", values);
};

export const GetQuizAttemptsService = async (values) => {
  return await axiosInstance().get("/getQuizAttempts", { params: values });
};

export const UploadDocument = async (values)=>{
  return await axiosInstance().post("/uploadDocument", values);
}
export const UploadDocumentToAws = async (values)=>{
  return await axiosInstance().post("/uploadDocumentAws", values);
}

export const GetQuestionsPreview = async (values) => {
  return await axiosInstance().get("/getQuestionsPreview", { params: values });
};

export const UploadAssessmentEvidence = async (values) => {
  return await axiosInstance().post("/uploadAssessmentEvidence", values);
};

export const RemoveAssessmentEvidence = async (values) => {
  return await axiosInstance().post("/removeAssessmentEvidence", values)
}

export const UploadStudentSignature = async (values) => {
  return await axiosInstance().post("/uploadStudentSignature", values);
}

export const AcceptedTermsCondition = async (values) => {
  return await axiosInstance().post("/acceptedTermsCondition",values)
}

export const RemoveStudentSignature = async (values) => {
  return await axiosInstance().post("/removeStudentSignature",values)
}
export const RemovedDocument = async (values) => {
  return await axiosInstance().post("/removedDocument", values);
};
export const RemovedDocumentToAws = async (values) => {
  return await axiosInstance().post("/removedDocumentAws", values);
};

export const InsertAttemptedQuestions = async (values) => {
  return await axiosInstance().post("/insertAttemptedQuestions", values);
}
